import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { LoginGuardService } from '../../api/login-guard.service';
import { IAccountType } from '../../constants/account-types';
import { DemoDataService, IAvailableSession, IBooking } from '../demo-data.service';
import { Subscription } from 'rxjs';
import { LangService } from '../../core/lang.service';
import { IAccountInfo } from '../view-mng-inst-accounts/view-mng-inst-accounts.component';
import { AuthService } from '../../api/auth.service';


@Component({
  selector: 'view-print-applicants',
  templateUrl: './view-print-applicants.component.html',
  styleUrls: ['./view-print-applicants.component.scss']
})
export class ViewPrintApplicantsComponent implements OnInit {

  public breadcrumb = [];

  bookings = [];

  routeSub:Subscription;

  sessionId:number;
  activeSession:IAvailableSession;
  availableSessions: IAvailableSession[];
  availableInvigilators: Partial<IAccountInfo>[];

  constructor(
    private auth: AuthService, // 
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private demoData:DemoDataService,
    public lang:LangService,
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    window.scrollTo(0,0);
    this.breadcrumb = [
      this.breadcrumbsService.TESTADMIN_LANDING(),
      this.breadcrumbsService.TESTADMIN_DASHBOARD(),
      this.breadcrumbsService._CURRENT( this.lang.tra('title_print_session_details'), this.router.url),
    ];
    this.routeSub = this.route.params.subscribe(routeParams => {
      this.sessionId = parseInt(routeParams['sessionId']);
      this.initRouteView()
    });
  }

  isInited:boolean;
  initRouteView(){
    this.auth.user().subscribe(userInfo => {
      if (userInfo && !this.isInited){
        this.isInited = true;
        this.loadSessionData(this.sessionId);
      }
    });
  }

  names:{firstName:string, lastName:string}[]
  loadSessionData(sessionId:number){
    this.activeSession = this.demoData.getSessionById(sessionId);
    this.names = []
    this.activeSession.bookings.forEach(booking => {
      const nameSplit = booking.name.split(' ')
      this.names.push({
        firstName: nameSplit[0],
        lastName: nameSplit[1],
      })
    })
    this.names = this.names.sort((a,b) => {
      if (a.lastName < b.lastName){
        return -1;
      }
      else if (a.lastName > b.lastName){
        return 1;
      }
      else if (a.firstName < b.firstName){
        return -1;
      }
      else if (a.firstName > b.firstName){
        return 1;
      }
      return 0
    })
  }

  renderLongTimestamp(m:moment.Moment){
    return m.format('h:mma, MMM. D, YYYY (dddd)')
    // 4:30pm, Sept. 22, 2020 (Wednesday)
  }

  renderShortDatestamp(m:moment.Moment){
    if (m){
      return m.format('ddd. MMM. D, YYYY')
    }
  }

  renderShortTimestamp(m:moment.Moment){
    if (m){
      return m.format('MMM. D') + ' at ' + m.format('h:mma')
    }
  }

  getInvigilName(invigilatorId:number){
    const invigil = this.demoData.getInvigilatorBasicInfo(invigilatorId);
    if (invigil){
      return invigil.name;      
    }
  }

  getInvigilEmail(invigilatorId:number, isBracketed:boolean = true){
    const invigil = this.demoData.getInvigilatorBasicInfo(invigilatorId);
    if (invigil){
      if (isBracketed){
        return '('+invigil.email+')';        
      }
      return invigil.email;      
    }
  }


}
